<template>
	<div class="honorStyleOne">
		<div class="HonorImg">
			<img :src="Img"/>
		</div>
		<div class="HonorLabel">
			<div class="HonorLabelTop">
				<div class="Labelline" v-for="(label,i) in itemAry[index]">
					<!-- {{label}} -->
					<div class="numberDiv">
						<span class="number">{{label.patent_num}}</span>
					</div>
					<div class="describeDiv">
						<div class="describe">{{label.patent_name}}</div>
					</div>
				</div>
			</div>
			<div class="HonorLabelbottom">
				<div class="bottom-tilte">{{Title + itmeNums}}</div>
				<div class="bottom-btn" v-if="Times.length > 5" @click="openNextPage" style="cursor: pointer;user-select: none;">
					<SvgIcon svg-name="signRightBlack" size="30"></SvgIcon>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SvgIcon from './SvgIcon.vue'
	
	export default{
		name:'honorStyleOne',
		props:{
			Title:{
				default:""
			},
			Img:{
				default:""
			},
			Times:{
				type:Array,
				default:()=>[]
			},
		},
		data() {
			return {
			}
		},		
		watch: {
			Times(newVal,oldVal) {
				let  that = this
				this.getTimes()
			}
		},
		created() {

		},
		computed:{
			itmeNums(){
				let that = this
				return ' ( ' + that.Times.length + ' ) '
			}
		},
		data(){
			return{
				itemAry:[],
				index:0,
				maxNum:0,
			}
		},
		methods:{
			openNextPage(){
				
				if(this.index <= this.maxNum){
					this.index++;
				}else{
					this.index = 0;
				}
			},
			getTimes() {
				let that = this
				let num = Math.ceil(that.Times.length/5)
				for (let i = 0; i < num; i++) {
					let ary = that.Times.slice(5*i,5*i+5)
					that.itemAry.push(ary);
				}
				that.maxNum = that.itemAry.length - 2;
					
			}
		},
		components:{
			SvgIcon
		}
	}
</script>

<style>
	.honorStyleOne {
		margin: 0 auto;
		height: 20rem;
		display: flex;
		flex-direction: row;
	}
	
	.honorStyleOne .HonorImg {
		height: 100%;
		width: 15.25rem;
		left: 0;
	}
	
	.honorStyleOne .HonorImg img {
		height: 100%;
		width: 100%;
	}
	
	.honorStyleOne .HonorLabel {
		height: 100%;
		width: 50rem;
		margin-left: 0.625rem;
		margin-right: 0;
		background-color: #F4F4F4;
		display: flex;
		flex-direction: column;
	}
	
	.honorStyleOne .HonorLabel .HonorLabelTop{
		display: flex;
		margin-top: 1.875rem;
		height: 60%;
		width: 100%;
		flex-direction: column;
		justify-content: flex-start;
	}
	
	.honorStyleOne .HonorLabel .HonorLabelTop .Labelline{
		font-size: 0.75rem;
		display: flex;
		flex-direction: row;
		flex-wrap:wrap;
		margin-top: 1.25rem;
		width: 100%;
		color: #5f5f5f;
		
	}
	
	.Labelline .numberDiv {
		margin-left: 2.25rem;
		width: 20%;
		display: flex;
		align-items: left;
	}
	
	.Labelline .numberDiv .number{
		border-bottom: #5f5f5f 1px solid;
		
	}
	
	.Labelline .describeDiv {
		width: 75%;
		display: flex;
		align-items: left;
	}
	
	.Labelline .describeDiv .describe {
		margin-left: 0.125rem;
	}
	
	.honorStyleOne .HonorLabel .HonorLabelbottom{
		
		width: 100%;
		height: 20%;
		margin-top: 1.85rem;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.honorStyleOne .HonorLabel .HonorLabelbottom .bottom-tilte{
		font-size: 1rem;
		margin-top: 0.625rem;
		margin-left: 2.25rem;
	}
	
	.honorStyleOne .HonorLabel .HonorLabelbottom .bottom-btn{
		border: #00000 1px solid;
		background-color: rgba(0,0,0,0.1);
		height: 1.875rem;
		width: 7.5rem;
		margin-right: 1.875rem;
	}
	
</style>
